import FormValidator from '@/js/plugins/formValidator'
import FileUpload from '@/js/_components/FileUpload'
import Column from '@/js/plugins/column'
import { setSelectAction } from '@/js/_components/forms/input-select'
import { birthdayChangeAction } from '@/js/_components/parts/profile-add-guide';

const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

const main = () => {
    if (!document.querySelector('#page-user-profile-edit')) return

    const formValidator = new FormValidator({
        renderAreaSelector: '#input-form',
        renderErrorCnt: false,
        renderConfirmMessage: true,
        renderErrorPosition: 'outer',
    })

    birthdayChangeAction(formValidator.config.renderAreaObj);

    const fileUpload = new FileUpload({
        targetSelector: '.item[data-type="file"]',
        uploadDir: 'profile',
        fileSizeLimit: 25,
    })

    const fileColumn = new Column({
        columnsSelector: '#group-att-files .columns',
        maxSize: 3,
        editTmplFunc: (obj) => {
            obj.find('.preview p').remove()
        }
    })

    fileColumn.changeAfter = (baseObj, type, editObj) => {
        if (type == "add") {
            const obj = editObj.get(0);
            const checkObj = obj.querySelector('.input-check-container');
            formValidator.addTargetObject(checkObj)
            fileUpload.addTargetObj(obj)

            const fileObj = editObj.find('input[type="file"]')
            fileObj.trigger('click.fileUpload')
        }
    }

    const areaColumn = new Column({
        columnsSelector: '#group-live-areas .columns',
        maxSize: 3,
        editTmplFunc: (obj) => {
            obj.find('select option').each((idx, _obj) => {
                _obj.removeAttribute('selected')
            })
        }
    })

    areaColumn.changeAfter = (baseObj, type, editObj) => {
        if (type == "add") {
            const selectMenu = editObj.find('.c-forms-input-select__select-box');
            const obj = editObj.get(0);
            const checkObj = obj.querySelector('.input-check-container');
            if (selectMenu) {
                selectMenu.remove();
            }
            setSelectAction(obj)
            formValidator.addTargetObject(checkObj)
        }
    }

    // カラーピッカーの選択イベント
    const colorPicker = document.querySelector('.c-parts-color-picker');
    if (colorPicker) {
        colorPicker.addEventListener('colorChange', (e) => {
            const color = e.detail.color;
            console.log(color);
            document.querySelector('.form-item[data-type="accent_color"]').style.backgroundColor = color;
        });
    }
}
export default main
